import React, { useEffect, useState } from 'react'
import MyTabButtons from '../../../../../../../../../UI/form/tabButtons/MyTabButtons'

const SupplyBillChooseTab = ({ value, setValue }) => {

    const [list, setList] = useState([])

    useEffect(() => {
        setListData()
    }, [])

    useEffect(() => {
        if (!value) {
            setValue('add')
        }
    }, [])

    const setListData = () => {
        const listTemp = [
            {
                value: 'add',
                name: 'Створити новий'
            },
            {
                value: 'update',
                name: 'Додати в існуючий'
            },
        ]

        setList(listTemp)
    }

  return (
    <MyTabButtons 
        value={value}
        setValue={setValue}
        list={list}
    />
  )
}

export default SupplyBillChooseTab